import { render, staticRenderFns } from "./myApproval.vue?vue&type=template&id=1d50cd50"
import script from "./myApproval.vue?vue&type=script&lang=js"
export * from "./myApproval.vue?vue&type=script&lang=js"
import style0 from "./myApproval.vue?vue&type=style&index=0&id=1d50cd50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports